import { MsGrid } from '../ms-grid/ms-grid.interface';
import { MsServiceCoreService } from '../ms-service-core/ms-service-core.services';
import { MsGridService } from '../ms-grid/ms-grid.services';
import { Subject } from 'rxjs';
import { DataStateChangeEventArgs, GridComponent } from '@syncfusion/ej2-angular-grids';

export class SystemService {
	private readonly __msGrid: MsGrid;
	private readonly __serviceName: string;
	private __msServiceCoreService: MsServiceCoreService;

	constructor(
		serviceName: string,
		msGridService: MsGridService,
		msServiceCoreService: MsServiceCoreService
	) {
		this.__serviceName = serviceName;
		this.__msGrid = new MsGrid(msGridService);
		this.__msServiceCoreService = msServiceCoreService;
	}

	getServiceName(): string {
		return this.__serviceName;
	}

	create(data: any) {
		this.__msServiceCoreService.callAction({
			serviceName: this.getServiceName(),
			action: 'callback_create',
		});
	}

	read(data: any) {
		this.__msServiceCoreService.callAction({
			serviceName: this.getServiceName(),
			action: 'callback_read',
		});
	}

	update(data: any) {
		this.__msServiceCoreService.callAction({
			serviceName: this.getServiceName(),
			action: 'callback_update',
		});
	}

	delete(data: any) {
		this.__msServiceCoreService.callAction({
			serviceName: this.getServiceName(),
			action: 'callback_delete',
		});
	}

	getDataGrid(): Subject<DataStateChangeEventArgs> {
		return this.__msGrid.getDataGrid();
	}

	executeGrid(
		grid: GridComponent,
		state: DataStateChangeEventArgs,
		paginateRequest: (...args) => void
	): void {
		this.__msGrid.executeGrid(grid, state, paginateRequest);
	}
}
